<template>
    <div class="epf-filter-decor">
        <div class="epf-filter-decor__title">{{ filterConfig.title }}</div>
        <div class="epf-filter-decor__wrap">
            <template v-if="selectedOption">
                <div class="epf-filter__select__selection">
                    {{selectedOption.data.title}}
                    <global-button icon="close" theme="primary" class="epf-filter__select__clear" @click="onClearSelection" :disabled="freeze" />
                </div>
            </template>
            <global-button v-else @click="modalOpen = true" theme="secondary" class="button--spread">{{ $t('filter.selectDecor') }}</global-button>
        </div>

        <global-modal v-if="modalOpen"  @close="abort">
            <template slot="header">
                <div class="epf-filter-decor__tab-links">
                    <button class="epf-filter-decor__tab-link" :class="{'epf-filter-decor__tab-link--active': isModeText}" @click="mode = 'text'">{{ $t('filter.decor.byKeyword') }}</button>
                    <button class="epf-filter-decor__tab-link" :class="{'epf-filter-decor__tab-link--active': isModeFilter}" @click="mode = 'filter'">{{ $t('filter.decor.byFilter') }}</button>
                </div>

                <div class="row" v-show="isModeText">
                    <div class="epf-filter__input col-12 col-md-6 col-lg-4">
                        <div class="epf-filter__title">{{filterConfig.title}}</div>
                        <input class="search__field" type='text' maxlength='100' :placeholder="$t('filter.decor.keyword.placeholder')" v-model="text_query" :disabled="freeze">
                    </div>
                </div>
                <div class="row" v-show="isModeFilter">
                    <epf-filter-select v-if="filterFarben" :filter-config="filterFarben" additional-class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterGruppe" :filter-config="filterGruppe" additional-class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterHolz" :filter-config="filterHolz" additional-class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterStein" :filter-config="filterStein" additional-class="col-12 col-md-4 col-lg-3"/>
                </div>
            </template>
            <template slot="body">
                <div class="row">
                    <div class="col-12">
                        <global-loading-overlay :showLoading="freeze || text_freeze">
                            {{ $t('filter.decor.loading') }}
                        </global-loading-overlay>
                        <div v-if="text_result && availableDecors.length === 0">
                            {{ $t('filter.decor.keyword.noResult') }}
                        </div>
                        <template v-else>
                            <div class="row">
                                <div class="col-12">
                                    {{ availableDecors.length}} {{ $t('filter.decor.totalDecors') }}
                                </div>
                            </div>
                            <div class="row">
                                <div v-for="(decor, index) in availableDecors"
                                    class="col-4 col-md-2 col-xl-1 decor__col"
                                    :class="['group--' + groupTiles(index), index === selectedDecor ? 'decor__col--selected':'']"
                                    v-show="page === groupTiles(index)"
                                >
                                    <div class="decor__col--icon icon-item icon-item--ghost">
                                        <span class="icon icon--check-square" />
                                    </div>
                                    <global-material-tile :entity="decor.data" @click="selectedDecor = index"/>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

            </template>
            <template slot="pagination">
                <span class="pagination__indicator">{{ decorsShown }}</span>
                <global-button icon="arrow-left" @click="changePage(page-1)" theme="secondary" :class="page-1 < lowerEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
                <global-button icon="arrow-right" @click="changePage(page+1)" theme="secondary" :class="page+1 > upperEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
            </template>
            <template slot="controls__left">
                <global-button theme="secondary" @click="abort">{{ $t('filter.decor.close') }}</global-button>
            </template>
            <template slot="controls__right">
                <global-button theme="primary" @click="saveAndClose">{{ $t('filter.decor.select') }}</global-button>
            </template>
        </global-modal>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import EpfFilterSelect from '@epf/components/epf-filter-select/epf-filter-select';
import GlobalModal from "@global/global-elements/global-modal/global-modal";
import GlobalButton from "@global/global-elements/global-button/global-button";
import EpfFilterButtons from "../epf-filter-buttons/epf-filter-buttons";
import GlobalMaterialTile from "@global/global-elements/global-material-tile/global-material-tile.vue"
import {detectBreakpoint} from "@utilities/sal-breakpoint/sal-breakpoint";
import GlobalLoadingOverlay from '@global/global-elements/global-loading-overlay/global-loading-overlay';

const tilesPerPageConfiguration = {
    'xs': null,
    'sm': null,
    'md': 6,
    'lg': 6,
    'xl': 24
}

export default {
    name: "EpfFilterDecor",
    components: {GlobalLoadingOverlay, EpfFilterButtons, GlobalButton, GlobalModal, EpfFilterSelect, GlobalMaterialTile},
    data: function () {
        return {
            modalOpen: false,
            mode: 'text',

            page: 0,
            tilesPerPage: 12,

            selectedDecor: null,

            text_query: '',
            text_result: null,
            text_freeze: false,
            text_timeout: false,
            text_controller: null
        }
    },
    props: {
        filterConfig: Object,
    },
    computed: {
        ...mapState(['freeze']),
        isModeText() {
            return this.mode === 'text';
        },
        isModeFilter() {
            return this.mode === 'filter';
        },

        decorsShown() {
            return ((this.page * this.tilesPerPage) + 1) + ' - ' + (((this.page * this.tilesPerPage + this.tilesPerPage) > this.availableDecors.length) ? this.availableDecors.length : this.page * this.tilesPerPage + this.tilesPerPage);
        },
        upperEnd() {
            return Math.ceil(this.availableDecors.length / this.tilesPerPage) -1;
        },
        lowerEnd() {
            return 0
        },
        selectedOption() {
            // Wenn man bei nur einer Option die als Voausgwählt anzeigen will... Man müsste dann nur das X noch ausblenden
            // if (this.availableOptions.length === 1) {
            //     return this.availableOptions[0];
            // }
            const selectedValue = this.$store.getters.filterValueByName(this.filterConfig.name);
            if (selectedValue) {
                return this.filterDecor.options.find((option) => {
                    let val = option.value || option;
                    if (typeof val === 'number') {
                        return val === parseInt(selectedValue);
                    }
                    return val === selectedValue;
                });
            }
            return null;
        },
        filterDecor() {
            return this.$store.getters.filterByName('decor');
        },
        filterFarben() {
            return this.$store.getters.filterByName('color');
        },
        filterGruppe() {
            return this.$store.getters.filterByName('group');
        },
        filterHolz() {
            return this.$store.getters.filterByName('wood');
        },
        filterStein() {
            return this.$store.getters.filterByName('stone');
        },

        availableDecors() {
            let availableDecors = this.filterDecor.options;
            if (Array.isArray(this.$store.state.availableFilterValues[this.filterDecor.name])) {
                availableDecors = availableDecors.filter((option) => {
                    // Option überhaupt noch auswählbar?
                    if (!this.$store.state.availableFilterValues[this.filterDecor.name].includes(option.value)) {
                        return false;
                    }
                    // Über Stichwortsuche auswählbar?
                    if (Array.isArray(this.text_result) && !this.text_result.includes(""+option.value)) {
                        return false;
                    }
                    // Ansonten ist es auswählbar
                    return true;
                });

                // Reihenfolge über Stichwortsuche festlegen
                if (Array.isArray(this.text_result)) {
                    availableDecors = this.text_result.reduce(function(result, foundVal) {
                        const mapping = availableDecors.find(option => foundVal === (""+option.value));
                        if (mapping) {
                            result.push(mapping);
                        }
                        return result;
                    }, []);
                }
            }
            return availableDecors;
        }

    },
    watch: {
        mode: function(newMode) {
            if (newMode === 'text') {
                this.$store.dispatch('setFilterStates', {
                    filterStates: this.availableSubFilter()
                });
            }
            else if (newMode === 'filter') {
                this.text_query = '';
                this.text_result = false;
                this.text_freeze = false;
                if (this.text_timeout) {
                    clearTimeout(this.text_timeout);
                    this.text_timeout = false;
                }
            }
        },
        availableDecors: function() {
            this.page = 0;
            this.selectedDecor = null;
        },
        modalOpen: function (newVal) {
            if (newVal) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        },

        text_query: function (newVal) {
            if (this.text_timeout) {
                clearTimeout(this.text_timeout);
            }
            if (newVal && newVal.length > 0) {
                this.text_timeout = setTimeout(() => {
                if (this.controller) {
                    this.controller.abort();
                }
                    this.text_freeze = true;
                    this.controller = new AbortController();
                    fetch(window.EPF_DECOR_SEARCH_API + '&tx_salbase9_search[q]=' + encodeURIComponent(newVal),
                        {signal: this.controller.signal}
                    )
                        .then((response) => response.json())
                        .then((json) => {
                            if (json.decor && Array.isArray(json.decor.docs)) {
                                this.text_result = json.decor.docs;
                            } else {
                                this.text_result = false;
                            }
                            this.text_timeout = false;
                            this.text_freeze = false;
                    })
                    .catch(e => {/* In most cases, the request was just aborted */});
                }, 250);
            }
            else {
                this.text_result = false;
                this.text_timeout = false;
            }
        }
    },
    methods: {
        availableSubFilter() {
            const availableSubFilter = [];
            if (this.filterFarben) availableSubFilter.push({filterName: this.filterFarben.name, value: null});
            if (this.filterGruppe) availableSubFilter.push({filterName: this.filterGruppe.name, value: null});
            if (this.filterHolz) availableSubFilter.push({filterName: this.filterHolz.name, value: null});
            if (this.filterStein) availableSubFilter.push({filterName: this.filterStein.name, value: null});
            return availableSubFilter;
        },
        abort() {
            this.modalOpen = false;
            this.selectedDecor = null;
            this.text_query = '';

            this.$store.dispatch('setFilterStates', {
                filterStates: this.availableSubFilter()
            });
        },
        saveAndClose() {
            this.text_query = '';
            this.modalOpen = false;

            const filterStates = this.availableSubFilter();
            filterStates.push({filterName: this.filterConfig.name, value: this.availableDecors[this.selectedDecor].value});
            this.$store.dispatch('setFilterStates', {
                filterStates: filterStates
            });
            this.selectedDecor = null;
        },
        groupTiles(index) {
            return Math.floor(index / this.tilesPerPage)
        },
        changePage(index) {
            let normalizedPage = index < this.lowerEnd ? this.lowerEnd: index;
            normalizedPage = index > this.upperEnd ? this.upperEnd: normalizedPage;
            this.page = normalizedPage;
        },
        onClearSelection() {
            this.$store.dispatch('setFilterState', {
                filterName: this.filterConfig.name,
                value: null
            });
        }
    },
    mounted() {
        this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()]: this.filterDecor.options.length
        window.addEventListener('resize', () => {
            const oldTilePage = this.tilesPerPage;

            this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()]: this.filterDecor.options.length
            this.changePage(Math.floor(this.page * oldTilePage/this.tilesPerPage));
        });
    }
}
</script>
